import { Configuration, PopupRequest } from "@azure/msal-browser";

// Environment variables for Azure AD configuration
const clientId = process.env.REACT_APP_CLIENT_ID || "";
const tenantId = process.env.REACT_APP_TENANT_ID || "";

if (!clientId) {
  console.warn(
    "REACT_APP_CLIENT_ID is not set. Please create a .env file from .env.example",
  );
}

// Config object to be passed to Msal on creation
// Uses /common authority to support multi-tenant login (WMP + portfolio companies)
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: "/dashboard",
    postLogoutRedirectUri: "/",
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
  },
};

// Scopes for MS Graph API (user profile)
export const loginRequest: PopupRequest = {
  scopes: ["User.Read"],
};

// Scopes for MSAL token request. The access token goes to Graph (User.Read),
// but we only send the ID token to our backend API for user identification.
// The backend uses a separate app-only token for Power BI API calls.
export const powerbiRequest: PopupRequest = {
  scopes: ["User.Read"],
};

// MS Graph API endpoints
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

// Power BI API base URL
export const powerbiConfig = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:4000/api",
};
